// tslint:disable:max-line-length

import React from 'react';

export const ObjectTags = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M0,2v5l7,7l5-5L5,2H0z M7,2l7,7l-4,4l1,1l5-5L9,2H7z M3.5,4C4.3,4,5,4.7,5,5.5S4.3,7,3.5,7S2,6.3,2,5.5S2.7,4,3.5,4z" />
    </svg>
  );
};
